import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Ganhador0326 from "../../assets/images/ganhador-0326.jpg";
import AccordionAnt from "../AccordionAnt";
import "./Ganhadores.css";

export default function Ganhadores() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div>
      <div className="ganhadores-first-divider" />
      <Container fluid className="ganhadores-section">
        <Row id="ganhadores">
          <Col className="title-col-light">
            <h2 className="section-title-light">GANHADORES 2026</h2>
          </Col>
        </Row>
        <Container>
          <Row>
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              controls={false}
              indicators={false}
              touch={true}
            >
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0326}
                      alt="Ganhador de Março"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Março</h2>
                    </Row>
                    <Row>
                      <h3>MARIA ARABEL CHAGAS</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Ar-condicionado da marca
                          Electrolux
                          <br />
                          modelo JI12R Quente e frio, 12.000 btus
                        </p>
                        <p>
                          <span>Cidade: </span>Novo Hamburgo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>14/03/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>033267
                        </p>
                        <p>
                          <span>Número contemplado: </span>033278
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
            </Carousel>
          </Row>
        </Container>
      </Container>
      <div className="ganhadores-last-divider" />
      <AccordionAnt title="GANHADORES 2025" />
    </div>
  );
}
